import { NumericFormat } from "react-number-format";
import { isExistingBusiness } from "../../../../../utils/fieldAccess";
import { getBrokerOptions } from "./utils";
const removeIcon = require("../../../../../images/delete4.png");
function BrokerDetials({
  brokerModifiersData,
  allBrokerList,
  modifyBrokerList,
  index,
  styles,
  broker_commision,
}) {
  const isDisabled = isExistingBusiness();

  const getDefaultBrokerRate = () => {
    let rate = 0;

    try {
      if (brokerModifiersData.name) {
        const defaultBroker = allBrokerList.find(
          (element) => element.id === brokerModifiersData.name
        );
        rate = defaultBroker?.rate || 0;
      }
    } catch (error) {
      console.log(error);
      rate = 0;
    } finally {
      return rate;
    }
  };

  return (
    <div className={`${styles.blockContent} w-100`}>
      <div>Select Broker</div>
      <select
        disabled={isDisabled}
        name="brokers"
        id="brokers"
        className={`${styles.carrierValue} w-auto`}
        value={brokerModifiersData?.name || ""}
        onChange={(event) => {
          modifyBrokerList({
            operation: "update",
            index,
            key: "name",
            value: event.target.value,
          });
        }}
      >
        {getBrokerOptions(brokerModifiersData, allBrokerList)}
      </select>

      <NumericFormat
        disabled={isDisabled}
        value={
          brokerModifiersData?.value === null
            ? getDefaultBrokerRate()
            : brokerModifiersData.value
        }
        decimalScale={2}
        fixedDecimalScale
        suffix={"%"}
        allowNegative={false}
        onValueChange={(values) => {
          modifyBrokerList({
            operation: "update",
            index,
            key: "value",
            value: values.floatValue,
          });
        }}
        placeholder="0.00%"
      />

      <NumericFormat
        disabled
        value={broker_commision?.[index]?.commission_amount ?? 0}
        prefix="$"
        thousandSeparator
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        placeholder="$0.00"
      />

      <label className="checkbox-inline">
        <input
          disabled={isDisabled}
          type="checkbox"
          value="payroll"
          checked={brokerModifiersData?.type === "payroll"}
          onClick={() => {
            modifyBrokerList({
              operation: "update",
              index,
              key: "type",
              value: "payroll",
            });
          }}
        />
        Payroll
      </label>

      <label className="checkbox-inline">
        <input
          disabled={isDisabled}
          type="checkbox"
          value="premium"
          checked={brokerModifiersData?.type === "premium"}
          onClick={() => {
            modifyBrokerList({
              operation: "update",
              index,
              key: "type",
              value: "premium",
            });
          }}
        />
        Premium
      </label>

      {index !== 0 && (
        <div
          className={styles.removeBrokerSection}
          onClick={() => modifyBrokerList({ index, operation: "remove" })}
        >
          <img src={removeIcon} alt="remove broker" />
        </div>
      )}
    </div>
  );
}

export default BrokerDetials;
